/**
 * @description Logo
 */
import { FC, useMemo } from 'react';

import { useMediaQueryDevice } from '@/components/MediaQuery';
import { THEME_ENUM } from '@/constants';

import LogoLight from './assets/logo.svg?react';
import LogoDark from './assets/logo_dark.svg?react';

interface IPropTypes {
  dataTheme: THEME_ENUM;
  className?: string;
}
const Logo: FC<IPropTypes> = function ({ dataTheme, className }) {
  const { isMobile } = useMediaQueryDevice();
  const logo = useMemo(() => {
    return dataTheme === THEME_ENUM.DARK ? <LogoDark className={className} /> : <LogoLight className={className} />;
  }, [dataTheme, className]);
  const mobileLogo = useMemo(() => {
    return dataTheme === THEME_ENUM.DARK ? (
      <LogoDark height={24} className={className} />
    ) : (
      <LogoLight height={24} className={className} />
    );
  }, [dataTheme, className]);
  return <> {isMobile ? mobileLogo : logo}</>;
};

export default Logo;
